import React from "react";
import { BetSelections } from "@tvg/design-system";
import { VisualSelections } from "@tvg/ts-types/Bet";
import { LegBetSelectionsProps } from "../types";

const LegBetSelections = ({ selectionsList }: LegBetSelectionsProps) => (
  <>
    {selectionsList &&
      selectionsList.map((item: VisualSelections, index) => (
        <BetSelections
          key={`leg-bet-selections-${index.toString()}`}
          qaLabel={`leg-bet-slip-selections-${index.toString()}`}
          type={`L${index + 1}`}
          selections={item}
        />
      ))}
  </>
);

export default LegBetSelections;
